import React from 'react';

const PartnerCompanyUsersTable = ({ users }) => {
  if (!users.length) {
    return (
      <p className="partner-company-users-empty">No partner users assigned to this company.</p>
    );
  }

  return (
    <div className="partner-company-users-table-wrap">
      <table className="table partner-table partner-company-users-table">
        <thead>
          <tr>
            <th>Partner name</th>
            <th>Email</th>
            <th>Manager</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.id || `${user.email}-${index}`}>
              <td>{user.partnerName}</td>
              <td>{user.email}</td>
              <td>{user.manager}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PartnerCompanyUsersTable;
